/**
 * @file
 * The folder crumb row.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { button, icon, textSpan, setHidden, onClick } = berTags.dom;

  // Crumb row showing the current folder and navigating one level up.
  components.crumb = (crumbEl, { onBack }) => {
    const back = button('ber-tags__crumb-btn');
    back.appendChild(icon('back'));
    const label = textSpan('ber-tags__crumb-label', '');
    back.appendChild(label);
    crumbEl.appendChild(back);
    onClick(back, onBack);
    return {
      el: crumbEl,
      set: (text) => {
        label.textContent = text;
      },
      toggle: (hidden) => setHidden(crumbEl, hidden),
    };
  };
})(Drupal);
